module.exports = __webpack_public_path__ + "static/img/10.b807750.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/10.png
// module id = L/De
// module chunks = 0